module.exports = __webpack_public_path__ + "img/election_logo.b46f6bd9.png";